import React from 'react';
import jogajunto from 'assets/img/2026/jogajunto.png';
import conexao from 'assets/img/2026/conexao.png';
import simplifique from 'assets/img/2026/simplifique.png';
import todos from 'assets/img/2026/todos.png';
import './HeroIniciativas.scss';

interface HeroIniciativasProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
}

export const HeroIniciativas: React.FC<HeroIniciativasProps> = ({
  categoriaSelecionada,
  onCategoriaChange
}) => {
  const categorias = [
    { id: 'JOGA_JUNTO', nome: 'Joga Junto', imagem: jogajunto },
    { id: 'CONEXAO', nome: 'Prêmio Conexão', imagem: conexao },
    { id: 'simplifique', nome: 'Simplifique', imagem: simplifique },
    { id: 'todos', nome: 'Todos', imagem: todos },
  ];

  return (
    <div className="hero-iniciativas">
      <div className="hero-iniciativas__content">
        <h1 className="hero-iniciativas__title">
          Iniciativas do Prêmio BB 2026
        </h1>
        <p className="hero-iniciativas__subtitle">
          Explore, elogie e favorite as iniciativas <br></br> que estão transformando o BB
        </p>

        <div className="hero-iniciativas__categorias">
          <label className="hero-iniciativas__label">Selecione a categoria:</label>
          <div className="hero-iniciativas__categorias-grid">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                className={`hero-iniciativas__categoria-btn ${
                  categoriaSelecionada === categoria.id ? 'active' : ''
                }`}
                onClick={() => onCategoriaChange(categoria.id)}
                aria-label={`Filtrar por ${categoria.nome}`}
              >
                <img src={categoria.imagem} alt={categoria.nome} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
